import { render, staticRenderFns } from "./DashGreeting.vue?vue&type=template&id=62a4777c&"
import script from "./DashGreeting.vue?vue&type=script&lang=js&"
export * from "./DashGreeting.vue?vue&type=script&lang=js&"
import style0 from "./DashGreeting.vue?vue&type=style&index=0&id=62a4777c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports